
import { Component, Vue, Prop } from "vue-property-decorator";
import BtnRadio from "@common/src/components/scope/btn-radio/index.vue";
import dayjs from "dayjs";
import { getDateRange } from "@common/src/utils/common";
import t from "@common/src/i18n/t";

@Component({
  components: { BtnRadio }
})
export default class ChartDate extends Vue {
  @Prop({ default: false, type: Boolean })
  immediate: boolean;
  @Prop({ default: -1, type: Number })
  maxDay: number;
  @Prop({ default: -1, type: Number })
  maxMonth: number;
  @Prop({ default: false, type: Boolean })
  lastDay: boolean;
  @Prop({ default: false, type: Boolean })
  lastMonth: boolean;
  @Prop({ default: "auto", type: String })
  labelWidth: string;
  @Prop({ default: false, type: Boolean })
  showDateType: boolean;
  @Prop({ default: "", type: String })
  dayDefaultKey: string;

  DatePickerType = {
    Day: "1",
    Month: "2"
  };
  options = [
    { label: t("v210831.query-by-day"), value: this.DatePickerType.Day },
    { label: t("v210831.query-by-month"), value: this.DatePickerType.Month }
  ];
  selectedDate = [];
  selectedMonth = [];
  dateType = "1";
  created() {
    this.selectedDate = this.getDefault(this.DatePickerType.Day);
    this.selectedMonth = this.getDefault(this.DatePickerType.Month);
    this.immediate && this.handleEmitChange();
  }
  typeValue = this.DatePickerType.Day;
  getDefault(type: string): Array<Date> {
    if (type === this.DatePickerType.Day) {
      if (this.dayDefaultKey) {
        return getDateRange("today_to_today");
      } else {
        if (this.lastDay) {
          return getDateRange("first_day_to_yesterday_of_current_month");
        } else {
          return getDateRange("first_day_to_today_of_current_month");
        }
      }
    } else {
      if (this.lastMonth) {
        return getDateRange("first_month_to_last_month_of_current_year");
      } else {
        return getDateRange("first_month_to_current_month_of_current_year");
      }
    }
  }

  handleTypeChange() {
    this.handleEmitChange();
  }
  handleDateChange() {
    this.handleEmitChange();
  }
  handleDateTypeChange() {
    this.handleEmitChange();
  }
  handleEmitChange() {
    let format = [];
    if (this.typeValue === this.DatePickerType.Day) {
      const startDate = dayjs(this.selectedDate[0]);
      const endDate = dayjs(this.selectedDate[1]);
      format = [startDate.format("YYYYMMDD"), endDate.format("YYYYMMDD")];
      if (this.maxDay > 0) {
        const daysDiff = endDate.diff(startDate, "day");
        if (daysDiff > this.maxDay) {
          // this.selectedDate = [this.selectedDate[0], startDate.add(this.maxDay, "day").toDate()];
          return this.$message.error(t("v216_6.date-range-warning", [this.maxDay]));
        }
      }
    } else if (this.typeValue === this.DatePickerType.Month) {
      const startDate = dayjs(this.selectedMonth[0]);
      const endDate = dayjs(this.selectedMonth[1]);
      format = [startDate.format("YYYYMM"), endDate.format("YYYYMM")];
      if (this.maxMonth > 0) {
        const monthsDiff = endDate.diff(startDate, "month");
        if (monthsDiff + 1 > this.maxMonth) {
          // this.selectedMonth = [this.selectedMonth[0], startDate.add(this.maxMonth - 1, "month").toDate()];
          return this.$message.error(t("v216_6.month-range-warning", [this.maxMonth]));
        }
      }
    }
    this.$emit("dateChange", {
      type: this.typeValue,
      value: format,
      dateType: this.dateType
    });
  }
  pickeOptionsDate: any = {
    disabledDate: date => {
      if (this.lastDay) {
        return dayjs(date).isAfter(dayjs().subtract(1, "day").endOf("day"));
      } else {
        return dayjs(date).isAfter(dayjs().endOf("day"));
      }
    }
  };
  pickeOptionsMonth: any = {
    disabledDate: date => {
      if (this.lastMonth) {
        return dayjs(date).isAfter(dayjs().subtract(1, "month").endOf("month"));
      } else {
        return dayjs(date).isAfter(dayjs().endOf("month"));
      }
    }
  };
  dateTypeList: any = [
    {
      label: "按照收付款时间",
      value: "1"
    },
    {
      label: "按照创建时间",
      value: "2"
    }
  ];
}
